import { Component } from '@angular/core';

@Component({
  selector: 'rdrx-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss'],
})
export class ModalFooterComponent {}
